import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';

// Animations
const arrowBounce = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(5px); }
  60% { transform: translateY(3px); }
`;

// Container for text and arrow
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5rem auto 3rem;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;

// Styled text
const InfoText = styled.span`
  font-family: 'Orbitron', sans-serif;
  font-size: 14px;
  letter-spacing: 1px;
  color: rgba(100, 182, 255, 0.8);
  margin-bottom: 8px;
  text-transform: uppercase;
  transition: color 0.3s ease;
  
  ${ButtonContainer}:hover & {
    color: rgba(0, 255, 255, 0.9);
  }
`;

// Styled arrow
const Arrow = styled(FaChevronDown)`
  color: rgba(100, 182, 255, 0.7);
  font-size: 14px;
  animation: ${arrowBounce} 2s infinite ease-in-out;
  
  ${ButtonContainer}:hover & {
    color: rgba(0, 255, 255, 0.9);
  }
`;

const MoreInfoButtonUS = ({ onClick }) => {
  return (
    <ButtonContainer onClick={onClick}>
      <InfoText>More information</InfoText>
      <Arrow />
    </ButtonContainer>
  );
};

export default MoreInfoButtonUS;
